import { useQuery } from '@tanstack/react-query';
import { dataCentralApi } from '@/api/client';
import type { ResponseObject } from '@/types/shared';

/**
 * Quote of the day — the one dashboard source not owned by a per-widget module
 * (dashboard-personal / dashboard-scheduling / dashboard-feeds). Consumed by
 * QuoteBanner. `/quotes/random` returns data with the plain Keycloak bearer.
 */
export interface RandomQuote {
  quote: { content: string; author?: string; created_by_name?: string };
  source?: string;
}

export function useRandomQuote() {
  return useQuery({
    queryKey: ['dashboard', 'quote'],
    queryFn: async (): Promise<RandomQuote['quote'] | null> => {
      const res = await dataCentralApi.get<ResponseObject<RandomQuote>>('/quotes/random');
      return res.data?.result?.quote ?? null;
    },
    staleTime: 30 * 60_000,
  });
}
